namespace $ {

	$mol_style_define( $shm_markdown_text_list, {
		Continuation: {
			display: 'block',
			maxWidth: '100%',
		},
	} )

}
